<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form size="small" :inline="true" :model="user" label-width="80px" class="demo-form-inline">
                    <el-form-item label="用户名">
                        <el-input v-model="user.condition.userName" placeholder="用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名">
                        <el-input v-model="user.condition.userRealName" placeholder="姓名"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="queryUser">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="users"
                    size="small"
                    border
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    ref="tb">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column prop="userName" label="用户名" width="200"></el-table-column>
                    <el-table-column prop="userRealName" label="姓名" width="200"></el-table-column>
                    <el-table-column prop="roleName" label="角色" width="150"></el-table-column>
                    <el-table-column prop="phoneNo" label="手机号" width="200"></el-table-column>
                    <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
                    <el-table-column prop="userStatusDesc" label="状态" width="200"></el-table-column>
                    <el-table-column prop="outAccount" label="外部账号" width="200"></el-table-column>
                    <el-table-column prop="shortName" label="缩略名" width="200"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                    <el-table-column prop="remark" label="备注" width="200"></el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        <el-row class="user-search-button">
            <el-button size="small" type="primary" @click="handleCheckedUser">确定</el-button>
        </el-row>
    </div>
    
</template>

<script>
    import GlobeConstant from '../../assets/js/GlobeConstant.js';

    export default {
        name:'UserSearch',
        components: {
        },
        props:['roleCodeProp'],
        data() {
            return {
                user:{
                    condition:{
                        roleCode:"",
                        userStatus:"",
                    },
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                users: [],
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                userProp:{},
                title:"新增用户",
                dataStatuses:[],
                dialogFormVisible: false,
                formLabelWidth:"120px",
                selectedUser:{},
            }
        },
        methods: {
            update(row) {
                this.title = "修改用户";
                this.drawer = true;
                this.userProp = row;
                this.timer = new Date().getTime();
            },
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryUser();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryUser();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryUser();
                })
                .catch(() => {});
            },
            queryUser() {
                this.user.pageNum = this.currentPage;
                this.user.pageSize = this.pageSize;
                this.$axios.post("/user/find",this.user).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.users = res.data.result.list;
                            this.total = res.data.result.total;
                            // this.pageSize = res.data.result.size;
                            // this.currentPage = res.data.result.current;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            createUser() {
                this.title = "新增用户";
                this.drawer = true;
                this.timer = new Date().getTime();
                this.userProp = {};
            },
            queryUserStatus() {
                let condition = {value:"DATA_STATUS"};
                this.$axios.post("/dictionary/findByDictType",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.dataStatuses = res.data.result;
                        }else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            initCondition (data) {
                this.user.condition.roleCode = data;
                this.queryUser();
            },
            handleSelectionChange(selection) {
                if (selection.length > 1) {
                    this.$refs.tb.clearSelection();
                    this.$refs.tb.toggleRowSelection(selection.pop());
                }else if (selection.length === 1) {
                    this.selectedUser = selection.pop()
                } else {
                    this.selectedUser = {}
                }
            },
            handleCheckedUser() {
                this.$bus.$emit(GlobeConstant.usersearch_to_orderinfoupdate, this.selectedUser);
            }

        },
        mounted() {
            this.user.condition.roleCode  = this.roleCodeProp
            this.queryUserStatus();
            this.queryUser();
            
        },
        beforeDestroy() {

        }
        
    }


</script>

<style scoped>

    .el-row {
       margin-top: 10px;
       text-align: left;
       padding-left: 10px;
   }

   .block {
       text-align: right;
       margin-top: 10px;
   }
   .user-search-button {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
   }

   .user-search-button >.el-button {
        margin-top: 10px;
    }
</style>
